/* eslint-disable react/prop-types */
import { TableCell, TableRow } from '@mui/material';
import React from 'react'
import fixTableCellWidth from 'utils/fixTableCellWidth';
import separate from 'utils/separate';

function Row(props) {
    const { row } = props;
    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.ghollakName}
                    style={fixTableCellWidth("160px")}>{row.ghollakName}{row.locked}</TableCell>
                <TableCell className="tablecell" align="left" title={row.IOName}
                    style={fixTableCellWidth("160px")}>{row.IOName}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.IOBalance))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.IOBalance))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.balance))}
                    style={fixTableCellWidth("160px")}>{separate(Number(row.balance))}</TableCell>
                <TableCell className="tablecell" align="left" title={row.forDate}
                    style={fixTableCellWidth("160px")}>{new Date(row.forDate).toLocaleString("fa-IR").split(",")[0]}</TableCell>
                <TableCell className="tablecell" align="left" title={row.createdAt}
                    style={fixTableCellWidth("160px")}>{new Date(row.createdAt).toLocaleString("fa-IR")}</TableCell>
            </TableRow>
        </React.Fragment>
    );
}
function createData(id, ghollakName, IOName, IOBalance, balance, forDate, createdAt) {
    return {
        id,
        ghollakName,
        IOName,
        IOBalance,
        balance,
        forDate,
        createdAt
    };
}

export default function FullTableBody({data}) {
    const rows = data.map(item => createData(item.id, item?.ghollak?.name, item?.investment_opportunity?.name, item.investment_opportunity_balance,
        item.balance, item.for_date, item.created_at
    ));
    return (
        <>
            {rows.map((row) => (
                <Row key={row.id} row={row} />
            ))}
        </>
    )
}
